import styled from "styled-components";

export const SimCardAccountWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    position: relative;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0px;
    padding: 0px 20px;
`;

export const ToolBarLeftWrapper = styled.div`
    flex: 0 0 auto;
`;

export const ToolBarRightWrapper = styled.div`
    flex: 0 0 auto;
`;

export const AccountCardWrapper = styled.div`
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    padding: 20px;
`;

export const AccountCard = styled.div`
    width: 100%;
    background: #fff;
    overflow: hidden;
`;

export const AccountCardHeader = styled.div`
    background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
    padding: 24px 32px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
`;

export const AccountHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ProviderIcon = styled.div`
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
`;

export const AccountTitle = styled.div`
    font-size: 20px;
    font-weight: bold;
`;

export const AccountSubtitle = styled.div`
    font-size: 14px;
    opacity: 0.9;
    margin-top: 5px;
`;

export const BalanceDisplay = styled.div`
    text-align: right;
`;

export const BalanceLabel = styled.div`
    font-size: 14px;
    opacity: 0.9;
    margin: 5px 0px;
`;

export const BalanceValue = styled.div`
    font-size: 28px;
    font-weight: bold;
    font-family: 'DIN Alternate', 'Helvetica Neue', sans-serif;
`;

export const AccountCardBody = styled.div`
    padding: 32px;
`;

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 48px;
`;

export const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const InfoItemLabel = styled.div`
    font-size: 13px;
    color: #8c8c8c;
`;

export const InfoItemValue = styled.div`
    font-size: 16px;
    color: #262626;
    font-weight: 500;
`;

export const Divider = styled.div`
    height: 1px;
    background: #f0f0f0;
    margin: 24px 0;
`;

export const AccountCardFooter = styled.div`
    background: #fafafa;
    padding: 16px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #8c8c8c;
`;

export const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 200px;
`;

export const ChartsWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0px 20px;
    min-height: 0;
    width: 100%;
`;

export const ChartCard = styled.div`
    flex: 0 0 auto;
    padding: 20px;
    box-sizing: border-box;
`;

export const ChartTitle = styled.h3`
    margin: 0 0 15px 0;
    font-size: 16px;
    font-weight: bold;
    color: #333;
`;

export const ChartContainer = styled.div`
    width: 100%;
    height: 400px;
`;

export const DateRangeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0px ;

    & .ant-btn {
        padding: 15px 20px;
    }
`;
